import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=8aec883c&scoped=true"
import script from "./Header3.vue?vue&type=script&lang=js"
export * from "./Header3.vue?vue&type=script&lang=js"
import style0 from "./Header3.vue?vue&type=style&index=0&id=8aec883c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aec883c",
  null
  
)

export default component.exports